import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ArticleList from '../article-list';
import Button from '@material-ui/core/Button';
import { CircularProgress, Typography } from '@material-ui/core';
import { buildSidebarArticles } from './sidebar-articles';

function groupBy(list, props) {
  return list.reduce((a, b) => {
    const result = a;
    const value = b[props] == null ? '' : b[props];
    (result[value] = result[value] || []).push(b);
    return result;
  }, {});
}

class Sidebar extends Component {

  renderDefaultArticleList(articles) {
    const { localSettings } = this.props;

    return (
      <ArticleList
        labelPrinting={localSettings.labelPrinting}
        value={articles}
      />
    );
  }

  renderSideDishGroups(articles) {
    const { localSettings, classes } = this.props;
    const groups = groupBy(articles, 'name');

    return Object.keys(groups).map((groupKey) => {
      const group = groups[groupKey];
      const features = group[0] && group[0].features ? group[0].features : [];
      const showFeatureGroups = group.length > 1 || features.length > 1;

      return (
        <div key={`side-dish-${groupKey}`}>
          <div className={classes.articleContainer}>
            <Typography className={classes.quantity}>{group.reduce((acc, x) => x.quantity + acc, 0)}</Typography>
            <>
              <Typography className={classes.name}>
                {groupKey}
              </Typography>
            </>
          </div>
          {showFeatureGroups ? (
            <ArticleList
              labelPrinting={localSettings.labelPrinting}
              value={group
                .sort((a, b) => (a.features || []).join(', ').localeCompare((b.features || []).join(', ')))
                .map(x => ({ ...x, name: (x.features || []).join(', '), features: [] }))
              }
            />
          ) : null}
        </div>
      );
    });
  }

  renderGroupedArticleList(articles, groupProp, getTitle, keyPrefix, renderGroupArticles) {
    const groups = groupBy(articles, groupProp);
    const renderArticles = renderGroupArticles || (groupArticles => this.renderDefaultArticleList(groupArticles));

    return Object.keys(groups).map((groupKey) => (
      <div key={`${keyPrefix}-${groupKey}`}>
        <h2>{getTitle(groupKey)}</h2>
        {renderArticles(groups[groupKey])}
      </div>
    ));
  }

  getArticleList(articles) {
    const { localSettings, productionPlaces } = this.props;

    const groupByProductionPlaces = !!localSettings.showProductionPlaceFilter;
    const groupByState = !!localSettings.splitByState;
    const sideDishGroups = !!localSettings.sideDishGroups;
    const groupBySpotName = !!localSettings.groupSidebarBySpotName;

    if (groupBySpotName) {
      return this.renderGroupedArticleList(
        articles,
        'spotName',
        groupKey => groupKey || 'Ohne Standort/Tisch',
        'spot',
        groupArticles => (sideDishGroups
          ? this.renderSideDishGroups(groupArticles)
          : this.renderDefaultArticleList(groupArticles)),
      );
    }

    if (sideDishGroups) {
      return this.renderSideDishGroups(articles);
    }

    if (groupByState) {
      return this.renderGroupedArticleList(articles, 'stateName', groupKey => groupKey, 'state');
    }

    if (groupByProductionPlaces) {
      return this.renderGroupedArticleList(articles, 'productionPlaceId', (groupKey) => {
        const productionPlace = productionPlaces.find(x => x.productionPlaceId == groupKey);
        return productionPlace ? productionPlace.name : '';
      }, 'production-place');
    }

    return this.renderDefaultArticleList(articles);
  }
  render() {
    const { localSettings, 
      classes, 
      printArticleList, 
      isEPosPrinterEnabled, 
      showPrintAllOrders, 
      proceedAllVisibleOrders, 
      proceedingOrders, 
      isExpanded,
      toggleSidebar } = this.props;

    // const articleCounts = this.props.orders
    //   .flatMap(o => o.articles)
    //   .reduce((accumulator, current) => {
    //     const currentValue = accumulator[current.name] || 0;
    //     // eslint-disable-next-line no-param-reassign
    //     accumulator[current.name] = currentValue + current.quantity;
    //     return accumulator;
    //   }, {});

    // const articles = Object.keys(articleCounts).map(k => ({
    //   name: k,
    //   quantity: articleCounts[k],
    // }));

    const articles = buildSidebarArticles(this.props.orders, localSettings);

    return (
      <div className={classes.root} >
        {localSettings.splitByState
          ? (
            <div className={classes.hideToggle} onClick={toggleSidebar}>
              <div>
                {isExpanded ? '>' : '<'}
              </div> 
            </div>
          )
          : null
        }        
        <div
          className={classes.articleList}
        >
          {this.getArticleList(articles)}
        </div>

        {
          showPrintAllOrders ?
          (
            <div className={classes.buttonsContainer}>
              <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={() => proceedAllVisibleOrders()}
                  >{proceedingOrders 
                    ? 
                    (<CircularProgress size={25} />)
    
                    : 'Alle Bestellungen drucken'}</Button>              
            </div>
          )
          : null
        }
        {isEPosPrinterEnabled ?
          <div className={classes.buttonsContainer}>
            <Button
              variant="outlined"
              className={classes.button}
              onClick={() => printArticleList(articles)}
            >Artikelliste drucken</Button>
            {/* {this.renderRouteButtons()} */}
          </div>
          : null}
      </div>
    );
  }

  // renderRouteButtons() {
  //   const { classes, selectedMode, editRoutePlanning, finishRoutePlanning, isRoutePlanning, openRouteDialog } = this.props;
  //   if (selectedMode === "Route") {
  //     return (
  //       <div className={classes.routeButtonsContainer}>
  //         <Button
  //           variant="outlined"
  //           className={classes.button}
  //           onClick={isRoutePlanning ? finishRoutePlanning : editRoutePlanning}
  //         >{isRoutePlanning ? "Route speichern" : "Route bearbeiten"}
  //         </Button>
  //         <Button
  //           variant="outlined"
  //           className={classes.button}
  //           onClick={() => {
  //             if (isRoutePlanning)
  //               finishRoutePlanning()

  //             openRouteDialog();

  //           }}
  //         >Route berechnen
  //       </Button>
  //       </div>
  //     );
  // }
  // }
}

const styles = theme => ({
  root: {
    "box-shadow": "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
     "background-color": "#fff",
    display: 'flex',
    'flex-direction': 'column',
    height: `calc(100vh - ${theme.header.height}px )`,
    justifyContent: 'space-between',
    borderLeft: '1px solid lightgray',
    paddingLeft: '10px',
  },
  articleContainer: {
    display: 'flex',
    flex: 1,
    width: "100%",
    paddingLeft: '10px',
    marginTop: '20px',
    justifyContent: "space-between",
    fontWeight: 'bold',
    fontSize: '1.2em',
  },
  quantity: {
    width: theme.article.quantityWidth,
    fontWeight: 'bold',
    paddingLeft: '5px',
    textAlign: 'left',
  },
  name: {
    flex: 10,
    paddingLeft: '5px',
    fontWeight: 'bold',
  },
  hideToggle: {
    position: 'absolute',
    "box-shadow": "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    width: '40px',
    height: '40px',
    backgroundColor: 'white',
    borderRadius: '20px',
    marginLeft: '-25px',
    bottom: 70,
    zIndex: '1000',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    display: 'flex',
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  articleList: {
    // "flex-basis": "100%",
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  button: {
    fontSize: theme.order.buttons.fontSize,
    margin: '2px',
    flexGrow: 1,
  },
  routeButtonsContainer: {
    display: 'flex',
  },
  buttonsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  orders: PropTypes.array.isRequired,
  productionPlaces: PropTypes.array.isRequired,
  selectedMode: PropTypes.string.isRequired,
  finishRoutePlanning: PropTypes.func.isRequired,
  editRoutePlanning: PropTypes.func.isRequired,
  isRoutePlanning: PropTypes.bool.isRequired,
  openRouteDialog: PropTypes.func.isRequired,
  isEPosPrinterEnabled: PropTypes.bool.isRequired,
  localSettings: PropTypes.object.isRequired,
  proceedAllVisibleOrders: PropTypes.func.isRequired,
};


export default withStyles(styles)(Sidebar);
